module.exports = __webpack_public_path__ + "img/process_payment.4fe461d4.png";